import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContainerModule } from "@sitemule/ng-components/components/container";
import { BreadcrumbModule } from "src/app/shared/components/breadcrumb/breadcrumb.module";
import { FooterNavbarModule } from "src/app/shared/components/footer-navbar/footer-navbar.module";
import { FooterModule } from "src/app/shared/components/footer/footer.module";
import { NavbarModule } from "src/app/shared/components/navbar/navbar.module";
import { Frame1Module } from "../frame-1/frame-1.module";
import { AppFrame3Component } from "./frame-3.component";
@NgModule({
  declarations: [
    AppFrame3Component
  ],
  imports: [
    CommonModule,
    NavbarModule,
    BreadcrumbModule,
    FooterNavbarModule,
    Frame1Module,
    FooterModule,
    ContainerModule,
  ],
  exports:[AppFrame3Component],
  providers: [],
  bootstrap: [],
})
export class Frame3Module {}
